import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkPipe'
})
export class LinkPipe implements PipeTransform {
  transform(value: string): unknown {
    return value.startsWith('https://') || value.startsWith('http://')
      ? value
      : 'https://' + value;
  }
}
